(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["countdown_timer"] && !Shopify.designMode) return;
  try {
    (() => {
    function initCountdownTimer(el) {
      const minutesEl = el.querySelector('[data-minutes]');
      const secondsEl = el.querySelector('[data-seconds]');
      const endMessageEl = el.querySelector('[data-end-message-text]');
      const display = el.querySelector('.countdown-timer__display');

      let totalSeconds = parseInt(el.dataset.totalSeconds, 10);
      const restart = el.dataset.restart === 'true';
      const endMessage = el.dataset.endMessage;

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function tick() {
        if (totalSeconds <= 0) {
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';

          if (restart) {
            totalSeconds = parseInt(el.dataset.totalSeconds, 10);
          } else {
            if (endMessage && endMessageEl) {
              display.hidden = true;
              endMessageEl.hidden = false;
            }
            return; // stop ticking
          }
        }

        const mins = Math.floor(totalSeconds / 60);
        const secs = totalSeconds % 60;
        minutesEl.textContent = pad(mins);
        secondsEl.textContent = pad(secs);
        totalSeconds--;
      }

      tick(); // run immediately so there's no 1-second delay on load
      setInterval(tick, 1000);
    }

    document.querySelectorAll('[data-countdown-timer]').forEach(initCountdownTimer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.product-media-gallery__description-toggle');
    if (!toggle) return;

    const targetId = toggle.getAttribute('aria-controls');
    const textWrapper = document.getElementById(targetId);
    if (!textWrapper) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    const labelEl = toggle.querySelector('.product-media-gallery__description-toggle-label');

    toggle.setAttribute('aria-expanded', String(!isExpanded));
    textWrapper.dataset.collapsed = String(isExpanded);

    labelEl.textContent = isExpanded
      ? toggle.dataset.seeMoreLabel
      : toggle.dataset.seeLessLabel;
  });
  } catch(e) { console.error(e); }
})();

})();
